import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  blocks: "",
  class: /*#__PURE__*/_normalizeClass([
      'w-full',
      'mb-2'
    ])
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BlockIndex = _resolveComponent("BlockIndex")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.content, (block, index) => {
      return (_openBlock(), _createBlock(_component_BlockIndex, {
        key: index,
        block: block
      }, null, 8, ["block"]))
    }), 128))
  ]))
}